<template>
    <div class="kpiWrapper">
        <span class="font-1 value">
            {{currencyData}} {{decimalValue}}
        </span>
        <span class="font-5 text">
            {{text}}
        </span>
    </div>
</template>

<script>
import decimalFormat from 'services/filters/decimalFormat';
import consts from '../../consts';

export default {
    name: 'DashboardKPI',
    props: {
        value: Number,
        text: String,
        currency: String
    },
    computed: {
        currencyData() {
            return consts.currencyMap[this.currency] || '';
        },
        decimalValue() {
            return decimalFormat(this.value);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .kpiWrapper {
        margin-left: 16px;

        .value {
            color: $dark-300
        }

        .text {
            margin-left: 10px;
            color: $light-800;
        }
    }
</style>
